import { lazy, Suspense, useState } from 'react';
import Grid from '@mui/material/Grid';

import useTransition from 'src/interviews/hooks/useTransition';
import ResponsiveSurface from '../../../ResponsiveSurface';
import RichEndings from 'src/interviews/components/Completion/components/RichEndings';

import type { TreatmentPlan as TreatmentPlanType } from 'src/interviews/requests/sanity/requests/treatmentPlans/schemas';

const TreatmentPlanBody = lazy(() => import('./Body'));
export type Plan = TreatmentPlanType & {
  predictor: number;
  severities: string[];
  slug: string;
};
export interface ITreatmentPlanProps {
  plan: Plan;
  plans: TreatmentPlanType[];
}

// Treatment Plan derived from Sanity directly and not via buoy-gpt
const SanityTreatmentPlan = ({ plan, plans }: ITreatmentPlanProps) => {
  const transition = useTransition();

  const [showTreatmentPlan, setShowTreatmentPlan] = useState(true);

  const closeTreatmentPlan = () => {
    setShowTreatmentPlan(false);
    transition({
      event: 'BACK',
    });
  };

  return (
    <>
      <ResponsiveSurface
        isOpen={showTreatmentPlan}
        onClose={closeTreatmentPlan}
        modalHeader="Your treatment plan"
        backText="Back"
      >
        <Grid container spacing={2} direction="column" padding={2} paddingTop={1}>
          <Suspense fallback={null}>
            <TreatmentPlanBody interviewType="treatment" plan={plan} plans={plans} />
            <Grid item className="bp-w-full">
              <RichEndings interviewType="treatment" query={plan.condition_name} />
            </Grid>
          </Suspense>
        </Grid>
      </ResponsiveSurface>
    </>
  );
};

export default SanityTreatmentPlan;
